import {IDataModelTypeConfig} from "frontend/dataModels/types/IDataModelTypeConfig";

export const ClientFunctionDataModelTypeConfig: IDataModelTypeConfig = {
  fields: [
    'id',
    'name',
    'created_at',
    'updated_at'
  ],
  subscriptions: {
    items: 'ClientFunctionsChannel'
  },
  defaultColumns: [
    'name'
  ],
  columnConfig: {
    name: {
      label: 'Name',
      header: {
        sort: 'lower_name',
      },
      cell: {
        class: 'text-nowrap',
        kind: 'simple',
        path: 'name',
      },
    },
    createdDatetime: {
      label: 'Created Datetime',
      header: {
        sort: 'createdAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: clientFunction => ({
          t: clientFunction.createdAt,
        }),
      },
    },
    createdDate: {
      label: 'Created Date',
      header: {
        sort: 'createdAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: clientFunction => ({
          t: clientFunction.createdAt,
          format: 'dateOnly',
        }),
      },
    },
    createdTime: {
      label: 'Created Time',
      header: {
        sort: 'createdAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: clientFunction => ({
          t: clientFunction.createdAt,
          format: 'timeOnly',
        }),
      },
    },
    updatedDatetime: {
      label: 'Updated Datetime',
      header: {
        sort: 'updatedAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: clientFunction => ({
          t: clientFunction.updatedAt,
        }),
      },
    },
    updatedDate: {
      label: 'Updated Date',
      header: {
        sort: 'updatedAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: clientFunction => ({
          t: clientFunction.updatedAt,
          format: 'dateOnly',
        }),
      },
    },
    updatedTime: {
      label: 'Updated Time',
      header: {
        sort: 'updatedAt',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: clientFunction => ({
          t: clientFunction.updatedAt,
          format: 'timeOnly',
        }),
      },
    },
  }
}